<template>
  <div id="contenedor-listado-auditorias">
    <template
      v-if="$apollo.queries.auditoriasInformesObservacionesDetalles.loading">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody"
      ></v-skeleton-loader>
    </template>
    <template
      v-else>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="header in headers">
                <template>
                  <th :key="header.id">{{ header.text }}</th>
                </template>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="detalle in auditoriasInformesObservacionesDetalles">
              <template>
                <tr :key="detalle.id" class="body-1">
                  <td>
                    <v-chip dark small :color="getColorFechaVencimiento(detalle.fechaVencimiento)">
                      {{ detalle.fechaVencimiento }}
                    </v-chip>
                  </td>
                  <td>
                    {{ detalle.auditoriaObservacion.auditoriaInforme.auditoria.nombre }}
                  </td>
                  <td>
                    {{ detalle.auditoriaObservacion.auditoriaInforme.nombre }}
                  </td>
                  <td>
                    <v-row no-gutters class="rounded-lg grey lighten-5 pa-1 mb-1 mt-1">
                      <v-col cols="2">
                        <v-badge inline :content="detalle.auditoriaObservacion.numero">
                        </v-badge>
                      </v-col>
                      <v-col cols="10">
                        {{ detalle.auditoriaObservacion.descripcion }}
                      </v-col>
                    </v-row>
                  </td>
                  <td>
                    <div class="mb-1 mt-1">
                      <v-btn
                        class="text-capitalize"
                        color="info"
                        plain
                        small
                        @click="detallesContrato(detalle.contrato.id)">
                        {{ detalle.contrato.numero }}
                      </v-btn>
                    </div>
                    <div>
                      {{ detalle.texto }}
                    </div>
                  </td>
                  <!-- <td></td>
                  <td>
                    <span>
                      {{ detalle.contrato.contratista.nombreRazonSocial }}
                    </span>
                  </td> -->
                  <td>
                    <span>
                      {{ detalle.comentarios }}
                    </span>
                  </td>
                  <td>
                    <v-tooltip v-if="detalle.auditoriaObservacion.auditoriaInforme.dataFile" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          @click="verPdf(detalle.auditoriaObservacion.auditoriaInforme)">
                          <v-icon>mdi-file-pdf-box</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver PDF</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <template
                          v-if="detalle.seguimientos.length > 0">
                          <v-badge :content="detalle.seguimientos.length" overlap>
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="mostrarDetalleSeguimiento(detalle)">
                              <v-icon>mdi-timeline-plus-outline</v-icon>
                            </v-btn>
                          </v-badge>
                        </template>
                        <template
                          v-else>
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="agregarSeguimientoDetalleObservacion(detalle)">
                            <v-icon>mdi-timeline-plus-outline</v-icon>
                          </v-btn>
                        </template>
                      </template>
                      <span>Seguimiento ({{ detalle.seguimientos.length }})</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <ListadoToggle></ListadoToggle>
    <v-dialog
      v-model="mostrarPdfInforme"
      persistent
      scrollable
      width="750px">
      <v-card>
        <v-card-title>
          Vista previa PDF
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cancelarVerPdf()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf
            v-if="esteInforme"
            :ruta-archivo="esteInforme.dataFile">
          </VistaPreviaPdf>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mostrarRegistrarSeguimiento"
      persistent
      scrollable
      width="650px">
      <RegistrarObservacionDetalleSeguimiento
        v-if="esteDetalle"
        :detalle="esteDetalle"
        v-on:cerrar="cancelarRegistrarRespuesta"
        v-on:success="registroCompleto">
      </RegistrarObservacionDetalleSeguimiento>
    </v-dialog>
    <v-dialog
      v-model="mostrarSeguimientos"
      persistent
      width="650px">
      <v-card>
        <v-card-title>
          Seguimientos
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarMostrarSeguimiento">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <div class="d-flex mb-1 mt-1">
            <v-spacer></v-spacer>
            <custom-button
              iconText="mdi-plus"
              tipo="agregar"
              onlyIcon
              @click="agregarSeguimientoDetalleObservacion(esteDetalle)">
              Nuevo
            </custom-button>
          </div>
          <ListadoDetalleSeguimiento
            v-if="esteDetalle"
            :id-detalle="esteDetalle.id"
            v-on:success="registroCompleto">
          </ListadoDetalleSeguimiento>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer app right temporary :value="esteIdContrato !== null" width="350px">
      <v-card flat>
        <v-card-title>
          Contrato
          <v-spacer></v-spacer>
          <v-btn
            @click="esteIdContrato = null"
            icon>
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <contrato-detalles
            v-if="esteIdContrato"
            :id-contrato="esteIdContrato">
          </contrato-detalles>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES from '@/graphql/querys/administracion/auditorias/auditoriasInformesObservacionesDetalles.gql';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import RegistrarObservacionDetalleSeguimiento from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Nueva.vue';
import ContratoDetalles from '@/components/administracion/contratos/ContratoDetalles.vue';
import ListadoDetalleSeguimiento from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Listado.vue';
import CustomButton from '@/components/buttons/Button.vue';
import ListadoToggle from '@/views/administracion/auditorias/seguimiento/Main.vue';

export default {
  name: 'MainListadoDetallesObservaciones',
  components: {
    VistaPreviaPdf,
    RegistrarObservacionDetalleSeguimiento,
    ContratoDetalles,
    ListadoDetalleSeguimiento,
    CustomButton,
    ListadoToggle,
  },
  data() {
    return {
      headers: [
        {
          id: 'fecha-vencimiento',
          text: 'F. Vencimiento',
        },
        {
          id: 'auditoria',
          text: 'Auditoría',
        },
        {
          id: 'informe',
          text: 'Informe',
        },
        {
          id: 'observacion',
          text: 'Observación',
        },
        {
          id: 'accion-documento-pendiente',
          text: 'Acción o Documento Pendiente',
        },
        {
          id: 'comentarios',
          text: 'Comentarios',
        },
        {
          id: 'acciones',
          text: '',
        },
      ],
      filtros: {
        fechaVencimiento: null,
        fueEnviada: null,
        estatus: null,
      },
      mostrarPdfInforme: false,
      mostrarRegistrarSeguimiento: false,
      mostrarSeguimientos: false,
      esteDetalle: null,
      esteInforme: null,
      esteIdContrato: null,
    };
  },
  apollo: {
    auditoriasInformesObservacionesDetalles: {
      query: AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES,
      variables() {
        return {
          filtros: this.filtros,
        };
      },
    },
  },
  methods: {
    async refrescarListado() {
      await this.$apollo.queries.auditoriasInformesObservacionesDetalles.refetch({
        filtros: this.filtros,
      });
    },
    registroCompleto() {
      this.refrescarListado();
    },
    verPdf(informe) {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = informe;
    },
    cancelarVerPdf() {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = null;
    },
    getColorFechaVencimiento(fechaVencimiento) {
      const formatedFechaVencimiento = new Date(`${fechaVencimiento}`);
      const hoy = new Date();
      const diferenciasEnMilisegundos = formatedFechaVencimiento - hoy;

      const diferenciasEnDias = Math.floor(diferenciasEnMilisegundos / (1000 * 60 * 60 * 24));

      if (diferenciasEnDias <= 0) return '#EF5350';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'warning';

      return 'success';
    },
    agregarSeguimientoDetalleObservacion(detalle) {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
      this.esteDetalle = detalle;
    },
    cancelarRegistrarRespuesta() {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
    },
    detallesContrato(id) {
      this.esteIdContrato = id;
    },
    mostrarDetalleSeguimiento(idDetalle) {
      this.esteDetalle = idDetalle;
      this.mostrarSeguimientos = !this.mostrarSeguimientos;
    },
    cerrarMostrarSeguimiento() {
      this.esteDetalle = null;
      this.mostrarSeguimientos = false;
    },
  },
};
</script>

<style lang="scss">

</style>
